import { render, staticRenderFns } from "./avantages.vue?vue&type=template&id=01f0f215"
import script from "./avantages.vue?vue&type=script&lang=js"
export * from "./avantages.vue?vue&type=script&lang=js"
import style0 from "./avantages.vue?vue&type=style&index=0&id=01f0f215&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports